export const fakeUser = {
  user: {
    uid: '123',
    displayName: 'FAKE',
    photoURL: 'https://lh3.googleusercontent.com/a-/AAuE7mCL-QG81mJI2e-lkwpQd5-sC1CFaxweAz-NqaQatA=s96',
  },
};
